<template>
  <div>
    <div v-if="user.company.labels.length > 0 && dossier.labelIds">
      <v-hover v-slot="{ hover }">
        <div :class="{ 'hoveredBackground': hover }" class="cursorPointer" @click="showEditLabelsDialog">
          <v-banner class="banner-without-padding py-1" style="top:50px; z-index:1" sticky color="primary" single-line>
            <v-layout wrap>
              <v-flex xs12 class="primary white--text" text-center>
                <h3>
                  <span>{{ $t('1') }}</span>
                  <v-icon small class="ml-2" :class="{ 'white--text': hover, 'primary--text': !hover }">mdi-pen</v-icon>
                </h3>
              </v-flex>
            </v-layout>
          </v-banner>
          <v-divider/>
          <v-layout wrap>
            <v-flex xs12 v-if="labelIds.length > 0" class="quillAsHtmlContainer" pl-1 pr-3 text-center>
              <v-chip label v-for="(labelId, key) in labelIds" :key="key" class="mx-3 my-1 cursorPointer" small>
                <span>{{ getLabelById(labelId).name }}</span>
              </v-chip>
            </v-flex>
            <v-flex xs12 v-else>
              <v-layout wrap>
                <v-flex xs3></v-flex>
                <v-flex xs9 pl-2>
                  <i>{{ $t('2') }}</i>
                </v-flex>
              </v-layout>  
            </v-flex>
          </v-layout>
        </div>
      </v-hover>
    </div>

    <v-dialog v-model="isShowingEditLabelsDialog" width="30%">
      <v-card class="px-12 pb-6 pt-6">
        <v-layout wrap>
          <v-flex xs12 text-center>
            <h4>{{ $t('3') }}</h4>
          </v-flex>
          <v-flex xs12>
            <div v-for="(label, key) in user.company.labels" :key="key">
              <v-checkbox v-model="labelIds" outlined dense hide-details :value="label.id">
                <template v-slot:label>
                  <small class="primary--text">{{ label.name }}</small>
                </template>
              </v-checkbox>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  props: {
    dossier: Object,
  },
  data: () => ({
    isShowingEditLabelsDialog: false,
    labelIds: []
  }),
  computed: {
    ...mapGetters({
      user: "user"
    }),
  },
  async mounted() {
    if (!this.dossier.labelIds) this.dossier.labelIds = []
    this.labelIds = JSON.parse(JSON.stringify(this.dossier.labelIds))
  },
  methods: {
    showEditLabelsDialog() {
      this.isShowingEditLabelsDialog = true
    },
    getLabelById(labelId) {
      return this.user.company.labels.find(label => label.id === labelId)
    }
  },
  watch: {
    labelIds: {
      handler() {
        this.dossier.labelIds = JSON.parse(JSON.stringify(this.labelIds)).sort((a, b) => b.name > a.name ? -1 : 1)
        this.$forceUpdate()
      },
    },
    isShowingEditLabelsDialog: {
      handler(val) {
        if (!val) {
          this.$emit('updateProfileAndCreateDossier', { isOnlyToUpdateProfile: true })
        }
      }
    }
  }
  
}
</script>


<i18n>
{
  "fr": {
    "1": "Labels",
    "2": "Aucun label associé.",
    "3": "Associer des labels à ce dossier"
  },
  "en": {
    "1": "Labels",
    "2": "No label.",
    "3": "Tag this CV with labels"
  }
}
</i18n>